import React from 'react';

const DynamicFormIcon = () => {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_42_91)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <path
            d='M25.9965 34.8182V21H51.375L57.5 27.0455V59H45.25M48.75 21V29.6364H57.5M33 43.4545V38.2727M33 43.4545C34.3924 43.4545 35.7277 44.0005 36.7123 44.9723C37.6969 45.944 38.25 47.2621 38.25 48.6364M33 43.4545C31.6076 43.4545 30.2723 44.0005 29.2877 44.9723C28.3031 45.944 27.75 47.2621 27.75 48.6364M33 53.8182C34.3924 53.8182 35.7277 53.2722 36.7123 52.3005C37.6969 51.3287 38.25 50.0107 38.25 48.6364M33 53.8182C31.6076 53.8182 30.2723 53.2722 29.2877 52.3005C28.3031 51.3287 27.75 50.0107 27.75 48.6364M33 53.8182V59M38.25 48.6364H43.5M27.75 48.6364H22.5M26 41.7273L29.5 45.1818M36.5 52.0909L40 55.5455M40 41.7273L36.5 45.1818M29.5 52.0909L26 55.5455'
            stroke='#FEFEFE'
            stroke-width='1.5'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_42_91'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_42_91'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default DynamicFormIcon;
